export default __webpack_public_path__ + "assets/gold_rush.dff9bcdd.png";